<template>
  <v-row class="white--text" justify="center" align-content="center">
    <v-col class="virus-bg" cols="6">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          感染者数
        </v-col>
        <v-col class="display-1 text-center font-weight-bold" cols="12" align-self="end">
          {{infectionTotal}}
        </v-col>
      </v-row>
    </v-col>
    <v-col class="bed-bg" cols="6">
      <v-row align="center">
        <v-col class="title text-center" cols="12">
          入院・療養中
        </v-col>
        <v-col class="display-1 text-center font-weight-bold" cols="12" align-self="end">
          {{hospitalize}}
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'infectionGrphicSimple',
  props: {
    backgroundColor: { type: [String], default: 'gray' },
    infectionTotal: { type: [Number], default: 0 },
    hospitalize: { type: [Number], default: 0 },
  },
  data: () => ({
  }),
  computed: {
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.virus-bg {
  background-image: url("~@/assets/virus.svg");
  background-position: center center;
  background-repeat: no-repeat;
}

.bed-bg {
  background-image: url("~@/assets/bed.svg");
  background-position: center center;
  background-repeat: no-repeat;
}

.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}
</style>
